"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

var _withNullIfStaticBuild = _interopRequireDefault(require("../../../withNullIfStaticBuild"));

var _ProductDetailStockInfoDesktop = _interopRequireDefault(require("./ProductDetailStockInfoDesktop"));

var _ProductDetailStockInfoMobile = _interopRequireDefault(require("./ProductDetailStockInfoMobile"));

// HOC for static build
function ProductDetailStockInfo(props) {
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  return mobile ? /*#__PURE__*/_react.default.createElement(_ProductDetailStockInfoMobile.default, props) : /*#__PURE__*/_react.default.createElement(_ProductDetailStockInfoDesktop.default, props);
}

process.env.NODE_ENV !== "production" ? ProductDetailStockInfo.propTypes = {
  available: _propTypes.default.bool,
  classes: _propTypes.default.shape({
    container: _propTypes.default.string,
    free: _propTypes.default.string,
    labelsContainer: _propTypes.default.string,
    notAvailable: _propTypes.default.string,
    root: _propTypes.default.string,
    separator: _propTypes.default.string,
    showroom: _propTypes.default.string,
    text: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  delInfo: _propTypes.default.shape({
    deliveryDates: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    warehouse: _propTypes.default.string
  }),
  product: _propTypes.default.shape({
    adornments: _propTypes.default.arrayOf(_propTypes.default.shape({})),
    id: _propTypes.default.string.isRequired,
    stockQuantity: _propTypes.default.shape({
      available: _propTypes.default.bool,
      detail: _propTypes.default.arrayOf(_propTypes.default.shape({
        date: _propTypes.default.string,
        icon: _propTypes.default.node,
        location: _propTypes.default.string
      }))
    })
  }),
  renderToGridArea: _propTypes.default.string,
  shipping: _propTypes.default.shape({
    latestOrderTime: _propTypes.default.shape({}),
    shippingDate: _propTypes.default.shape({}),
    warehouse: _propTypes.default.string
  })
} : void 0;
ProductDetailStockInfo.defaultProps = {
  available: false,
  classes: undefined,
  className: undefined,
  delInfo: undefined,
  product: undefined,
  renderToGridArea: 'stockInfo',
  shipping: undefined
};

var _default = (0, _withNullIfStaticBuild.default)(ProductDetailStockInfo);

exports.default = _default;